const pxToRem = value => value === 0 ? '0' : `${value / 16}rem`;

export { pxToRem as p };
